import { eimzo } from '@/entities/eimzo';
import { CabinetWrapper } from '@/shared/cabinet-wrapper';
import { Box, Button, FormControl, Stack, TextField } from '@mui/material';
import { useState } from 'react';

const TestPage = () => {
  const [value, setValue] = useState('');
  const [signature, setSignature] = useState('');

  const handleSign = async () => {
    try {
      const cert = await eimzo.getCertificate(value);
      if (!cert) {
        return window.alert('Certificate not found');
      }
      const res = await eimzo.sign(value, value);
      setSignature(res);
    } catch (error) {
      window.alert(error);
    }
  };

  return (
    <CabinetWrapper>
      <Stack direction='row' spacing={2}>
        <FormControl>
          <TextField value={value} onChange={(e) => setValue(e.target.value)} />
        </FormControl>

        <Button onClick={handleSign}>Подписать</Button>
      </Stack>

      <Box sx={{ mt: 4 }}>
        <Box component='p'>{signature}</Box>
      </Box>
    </CabinetWrapper>
  );
};

export default TestPage;
